import common from "./common.json";
import date from "./date.json";
import errors from "./errors.json";
import login from "./login.json";
import order from "./order.json";
import table from "./table.json";
import production from "./production.json";
import pagetitles from "./pagetitles.json";

export const da = {
  common,
  date,
  errors,
  login,
  order,
  pagetitles,
  table,
  production,
};
